/**
 * lightField — the djmsqrvve drifting blurred-light bed (a managed cloud of
 * SoftLights). Migrated from the lightField half of the old softLightScene.
 * Reports lightCount for the VQA `__atmosphere.softLightCount`. Under reduced
 * motion the lights hold still.
 */
import { registerEffect, makeContentHandle, type EffectBuilder } from '../effectBuilders';
import { LightField } from '../../vfx/LightField';
import { Z_LAYERS } from '../../../rendering/Z_LAYERS';
import { getMotionPrefs } from '../../../systems/accessibility/motionPrefs';

const buildLightField: EffectBuilder = (layer, ctx) => {
  if (layer.kind !== 'lightField') return null;
  const field = new LightField(layer, ctx.region, { seed: ctx.seed, depth: Z_LAYERS.ATMOSPHERE, parent: ctx.layerContainer, still: getMotionPrefs().reduceMotion });
  return makeContentHandle({ lightCount: () => field.size(), onDestroy: () => field.destroy() });
};

registerEffect({ kind: 'lightField', build: buildLightField, depth: Z_LAYERS.ATMOSPHERE });
